import React, { useState } from "react";
import styles from './TabContainer.module.scss'
import UserManagerTab from "./UserManagerTab";
import CreateBlogTab from "./CreateBlogTab";
import PreviewBlogTab from "./PreviewBlogTab"
import EditBlogTab from "./EditBlogTab";

const TabContainer = () => {
  const [activeTab, setActiveTab] = useState("user-manager");

  const tabs = [
    {
      id: "user-manager",
      label: "User Manager",
      content: <UserManagerTab />
    },
    {
      id: "create-blog",
      label: "Create Blog Post",
      content: <CreateBlogTab />
    },
    {
      id: "preview-posts",
      label: "Staging",
      content: <PreviewBlogTab />
    },
    {
      id: "edit-blog",
      label: "Edit Blog Posts",
      content: <EditBlogTab />
    }
  ];

  return (
    <div>
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`${styles.tab} ${
                activeTab === tab.id ? styles.active : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.contentContainer}>
        {tabs.find(tab => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default TabContainer;
